// import { Link } from 'react-router-dom'

const Footer = () => {
//   const scrollTop = () => {
//     window.scrollTo({ top: 0, behavior: 'smooth' })
//   }
  return (
    <footer className='bg-gray-500 p-3 shadow footer'>
      {/* <div className='p-5'>
        <ul className='flex items-center justify-center text-slate-300 font-bold text-xs'>
          <li className='cursor-pointer hover:text-white transition-all ease-in duration-500 pr-5'>
            <Link to='/' onClick={scrollTop}>Bài</Link>
          </li>
          <li className='cursor-pointer hover:text-white transition-all ease-in duration-500 pr-5'>
            <Link to='/quoc' onClick={scrollTop}>Quốc</Link>
          </li>
          <li className='cursor-pointer hover:text-white transition-all ease-in duration-500 pr-5'>
            <Link to='/us' onClick={scrollTop}>US</Link>
          </li>
          <li className='cursor-pointer hover:text-white transition-all ease-in duration-500 pr-5'>
            <Link to='/loi' onClick={scrollTop}>Lời Hứa</Link>
          </li>
          <li className='cursor-pointer hover:text-white transition-all ease-in duration-500 pr-5'>
            <Link to='/moi' onClick={scrollTop}>Mới Tới</Link>
          </li>
          <li className='cursor-pointer hover:text-white transition-all ease-in duration-500'>
            <Link to='/anh' onClick={scrollTop}>Anh Em</Link>
          </li>
        </ul>
      </div> */}
      <div className='bg-slate-900 p-5 rounded'>
        <span className='text-slate-300 flex items-center justify-center text-sm'>© 2023 All rights reserved.</span>
      </div>
    </footer>
  )
}

export default Footer
